<button type="button" class="btn focus-visible border-0 p-0" (click)="copyText()">
  @if (!copied) {
    <span
      class="material-icons material-symbols-outlined fs-6 px-2 lh-base"
      @copyFadeIn
      [@.disabled]="copied"
    >
      content_copy
    </span>
  }
</button>

@if (copied) {
  <span class="material-icons material-symbols-outlined copied fs-6 px-2 lh-base"> done_all </span>
}
